import React, { ChangeEvent } from 'react';

export type SelectOption = {
  value: string | number;
  label: string;
}

type SelectInputBoxProps= {
  label: string;
  required?: boolean;
  options: SelectOption[];
  value?: string;
  placeholder?: string;
  onChangeFunctions: ((value?: string) => void)[];
  size?: string;
  contactBoxCt?: string   
}

type SelectInputProps= {
  options: SelectOption[];
  value?: string;
  placeholder?: string;
  onChangeFunctions: ((value?: string) => void)[];
  size?: string;
  contactBoxCt?: string   
}

export const SelectInput: React.FC<SelectInputProps> = ({ options, value, placeholder, onChangeFunctions, size = "", contactBoxCt = "contact-box__ct" }) => {

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const newValue = event.target.value;
    onChangeFunctions.forEach(func => func(newValue));
  };

  return(
    <div className={`select-custom ${size} ${contactBoxCt}`}>
      <select value={value} onChange={handleChange}>
        {placeholder && <option value="">{placeholder}</option>}
        {options.map(option => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </select>
    </div>
  )
};

export const SelectInputBox: React.FC<SelectInputBoxProps> = ({ label, required = false, options, value, placeholder, onChangeFunctions, size = "", contactBoxCt = "contact-box__ct" }) => {

  return(
    <div className="contact-box__item">
      <label className="contact-box__ttl">
        <span>{label}</span>
        {required && <small>必須</small>}
      </label>
      <SelectInput options={options} value={value} placeholder={placeholder} onChangeFunctions={onChangeFunctions} size={size} contactBoxCt={contactBoxCt} />
    </div>
  )
};
